import React from 'react';

import saveIcon from 'assets/sidebar-save.svg';

const SidebarSaveIcon = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}): JSX.Element => (
  <img
    src={saveIcon}
    alt="save-icon"
    className={`save-icon ${className}`}
    onClick={() => onClick()}
  />
);

export default SidebarSaveIcon;
